import { Directive, HostListener, Input } from "@angular/core";

@Directive({
    selector: "[whatsAppTo]",
})
export class WhatsappToDirective {
    @Input("whatsAppTo") phone: string;

    @HostListener("click", ["$event"])
    onClick(event: any): void {
        if (this.phone) {
            this.phone = encodeURI(this.phone);
        var win = window.open(
            `https://wa.me/${this.phone}`,
        "_blank"
        );
        win.focus();
    }
    }
}
